
export default class
{
    project;
    tracked = {};

    constructor(project)
    {
        this.project = project || null;
    }

    trackOnce = data =>
    {
        if(!data || this.tracked[data]) return false;
        this.tracked[data] = true;
        this.trackMetric( data );
    }

    trackMetric = data =>
    {
        try
        {
            window.trackMetrics(
            {
                type: 'user-interaction',
      	        data: { interaction: 'interactive: ' + this.project + ' : ' + data }
            })
        }
        catch (err)
        {
            console.error(err)
        };
    }
}
